import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const GOOGLE_WRITE_REVIEW = 'https://www.google.com/maps?cid=1610033611455267559';

// Subtle post-purchase nudge to leave a Google review. Kept compliant:
// no health outcomes implied — it's about the experience only.
export const GoogleReviewPrompt = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.4 }}
    className="bg-white border border-border rounded-3xl p-6 md:p-8 mb-8 text-center"
    data-testid="google-review-prompt"
  >
    <div className="flex items-center justify-center gap-1 mb-3" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
      ))}
    </div>
    <h3 className="text-lg font-bold font-heading mb-1.5">Enjoying BCM-95®?</h3>
    <p className="text-sm text-muted-foreground max-w-md mx-auto mb-5">
      A quick Google review means the world to our small UK team — and helps others discover
      IIY Phytoventra. It only takes a moment.
    </p>
    <a
      href={GOOGLE_WRITE_REVIEW}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="leave-google-review-btn"
      className="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300"
    >
      <Star className="w-4 h-4" /> Leave a Google review
    </a>
  </motion.div>
);

export default GoogleReviewPrompt;
